import type { TextFieldProps } from '@mui/material';
import { useField } from 'formik';

import FloatNumberField from './FloatNumberField.tsx';

import type { ReactNode } from 'react';

export type FloatNumberFieldFormikProps = {
  name: string;
  maxLength?: number;
  adorn?: string;
} & TextFieldProps;

const FloatNumberFieldFormik = (
  props: FloatNumberFieldFormikProps,
): ReactNode => {
  const { name, ...rest } = props;

  const [field, meta] = useField(name);

  const hasError = meta?.touched;

  const getErrorProps = () => {
    if (!hasError) {
      return {};
    }

    if (typeof meta?.error === 'string') {
      return {
        error: !!meta?.error,
        helperText: meta?.error,
      };
    }

    return {};
  };

  const errorProps = getErrorProps();

  const inputProps = {
    'data-testid': name,
  };

  return (
    <FloatNumberField
      {...field}
      inputProps={inputProps}
      {...rest}
      {...errorProps}
    />
  );
};

export default FloatNumberFieldFormik;
